import { Footer } from "./ui/Footer";

export default Footer;
